export default "__VITE_ASSET__D3f07i$E__"